/**
 * Class description
 *
 * Created: 2019-08-01
 * @author jonas
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {TimelineLite, Timeline} from "gsap";
import {WinterHoardParsedGameData} from "../server/data/IWinterHoardServerData";
import {WinterHoardReelSymbol} from "../symbols/WinterHoardReelSymbol";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinterHoardLayerConfig} from "../config/WinterHoardLayerConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {WinterHoardGameModuleConfig} from "../WinterHoardGameModuleConfig";;

export class WinterHoardWildOverlayView extends BaseView {

    constructor() {
        super();
    }


    protected initAnimations():void {
        //TODO - Add some fancy graphics when the symbols are revealed.
        StageManager.getLayer(WinterHoardLayerConfig.WILD_OVERLAY.name).addChild(this);
    }

    /* TODO:
    *   Seem to be able to use this to update symbols before spin stop
    *
    */
    public update(data:WinterHoardParsedGameData, multipliers:number[], reelId:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        // W Overlayed (obsolete?)
        if(data.overlayWilds) {
            for(let i:number = 0; i < 3; i++) {

                if(data.overlayWilds[reelId][i]) {
                    // REMOVE
                    //tl.add(this.getAnimation(reelId, i, multipliers[reelId]), 0.2);
                }
            }
        }

        // Add energy on original M1:S
        if(data.evaluatedReels) {
            data.evaluatedReels.forEach((symNameArr) => {
                symNameArr.forEach((symName) => {
                    if(symName === "M1") {

                    }
                });
            });
        }

        return tl;
    }

    public updateAll(data:WinterHoardParsedGameData, multipliers:number[]):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        for(let reelId:number = 0; reelId < 5; reelId++) {
            tl.add(this.update(data, multipliers, reelId));
        }
        return tl;
    }

    public getTransformNormal(overlayPositions:boolean [][] = []):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        /*[0,1,2,3,4].forEach((reelId) => {
            [0,1,2,3].forEach((symId) => {
                tl.add(() => {
                    const symbol: WinterHoardReelSymbol | null = <WinterHoardReelSymbol>Reels.getSymbol(reelId, symId);
                    if (!overlayPositions[reelId][symId]) {
                        symbol.playNormalSpine();
                    }
                });
            });
        });*/

        return tl;
    }

   public getEnergyAnimation(collectPositions:boolean [][], overlayPositions:boolean [][] = []):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        /*[0,1,2,3,4].forEach((reelId) => {
            [0,1,2,3].forEach((symId) => {
                tl.add(() => {
                    const symbol: WinterHoardReelSymbol | null = <WinterHoardReelSymbol>Reels.getSymbol(reelId, symId);
                    if (!overlayPositions[reelId][symId]) {
                        symbol.playNormalSpine();
                    }
                });
            });
        });*/

        collectPositions.forEach((boolArr, reelId) => {
            boolArr.forEach((bool, symbolId) => {
                if(bool) {
                    tl.add(() => {
                        const symbol: WinterHoardReelSymbol | null = <WinterHoardReelSymbol>Reels.getSymbol(reelId, symbolId);
                        if (symbol && overlayPositions[reelId][symbolId]) {
                            symbol.showEnergy();
                        }
                    });
                }
            });
        });

        return tl;
    }

    public hideEnergyAnimation(collectPositions:boolean [][], updateIndicatorTimelines:Timeline [] = [], level:number = 0, energyCollected:{before:number, after:number}):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        let totalCount:number = 1;
        const symStrings: string [] = [];

        const startCollect:number = energyCollected.before;
        const endCollect:number = energyCollected.after;


        // TODO: These calculations are incorrect, it should go on collectedBefore
        //console.log("Collect: ");
        //console.log(collectPositions);
        //console.log("boolArr: ");
        //console.log("HIDE CALL!");
        let time:number = -0.3;
        collectPositions.forEach((boolArr, reelId) => {
            //console.log("Collect pos iteration");
            let cntr:number = 0;
            boolArr.forEach((bool, symbolId) => {
                //console.log("bool arr iteration");
                if(bool) {
                    cntr++;
                    let symString:string = "";
                    let symLevel:number = 1;
                    if(totalCount <= (energyCollected.after - energyCollected.before) /*&& energyCollected.after <= 25*/) {
                                switch(energyCollected.before + totalCount) {
                                    case 1:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M5");
                                        break;
                                    case 2:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M5");
                                        break;
                                    case 3:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M5");
                                        break;
                                    case 4:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M5");
                                        break;
                                    case 5:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M5");
                                        break;
                                    case 6:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M4");
                                        break;
                                    case 7:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M4");
                                        break;
                                    case 8:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M4");
                                        break;
                                    case 9:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M4");
                                        break;
                                    case 10:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M4");
                                        break;

                                    case 11:
                                        /*console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);*/
                                        symStrings.push("M3");
                                        break;
                                    case 12:
                                        //console.log("collected before + totalCount: " + energyCollected.before +" + " +  totalCount);
                                        symStrings.push("M3");
                                        break;
                                    case 13:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M3");
                                        break;
                                    case 14:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M3");
                                        break;
                                    case 15:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M3");
                                    break;

                                    case 16:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M2");
                                        break;
                                    case 17:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M2");
                                        break;
                                    case 18:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M2");
                                        break;
                                    case 19:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M2");
                                        break;
                                    case 20:
                                        //console.log("collected before + totalCount: " + energyCollected.before + " + " + totalCount);
                                        symStrings.push("M2");
                                        break;
                                    default:
                                        //console.log("DEFAULT collected before + totalCount: " + energyCollected.before + " + " + totalCount + " DEFAULT");
                                        break;
                                }
                        totalCount++;
                    }
                    else {
                        symLevel = 0;
                    }

                    /*switch(level) {
                        case 1: symString = "M5"; break;
                        case 2: symString = "M4"; break;
                        case 3: symString = "M3"; break;
                        case 4: symString = "M2"; break;
                    }*/

                    tl.add(() => {
                        //console.log(symStrings);
                        //debugger;
                        const symbol: WinterHoardReelSymbol | null = <WinterHoardReelSymbol>Reels.getSymbol(reelId, symbolId);
                        if (symbol) {
                            symbol.collectEnergy();

                            if(updateIndicatorTimelines.length > 0) {
                                (<Timeline>updateIndicatorTimelines.shift()!.add([
                                    //()=>{SoundPlayer.playEffect(WinterHoardSoundConfig.PURPLE_DOT_FLY_TO_METER);},
                                    WinterHoardGameModuleConfig.energyCollector.playEnergyTransmission(symStrings.shift() || "", reelId, symbolId, cntr)
                                ]))!.play();
                                if(level > 0) {
                                    if(symString !== "") {
                                        //console.log("ENERGY TRANSMISSION SYM LEVEL: " + symString + " , REEL ID: " + reelId + " SYM ID: " + symbolId + ", LEVEL:  " + level);
                                        //WinterHoardGameModuleConfig.energyCollector.playEnergyTransmission(symString, reelId, symbolId);
                                    }
                                }
                            }
                        }
                    }, time += 0.3);
                    /*tl.add(
                        WinterHoardGameModuleConfig.energyCollector.playEnergyTransmission("M5", reelId, symbolId)
                    )*/

                    // TODO: Add to collector
                    //tl.add();
                }
            });
        });

        return tl;
    }

    private getAnimation(reelId:number, symbolId:number, multiplier:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            const symbol:WinterHoardReelSymbol | null = <WinterHoardReelSymbol>Reels.getSymbol(reelId, symbolId);

            // TODO: REMOVE; OLD FEATURE REMNANT
            if(symbol) {
                //symbol.replaceWith("W", reelId);
                //symbol.multiplier = multiplier;

            }
        });
        return tl;
    }

}